// extracted by mini-css-extract-plugin
export default {"trending":"TrendingItem_trending__AMchN"};